import React from "react";
import ReactTableV6Simple from "../CustomDataTables/ReactTableV6Simple";

const PlaylistScaffoldTable = (props) => {
    const rowCount = props.data.length === 0 ? 1 : props.data.length;
    const defaultPageSize = props.defaultPageSize || Math.min(rowCount, 10);

    return (
        <ReactTableV6Simple
            columns={props.columns}
            data={props.data}
            defaultPageSize={defaultPageSize}
            loading={props.loading || false}
            showPagination={props.data.length > defaultPageSize}
            showPaginationBottom={props.data.length > defaultPageSize}
        />
    );
};

export default PlaylistScaffoldTable;
